import { render } from "./ImagesPopup.vue?vue&type=template&id=1daa20b8&scoped=true"
import script from "./ImagesPopup.vue?vue&type=script&lang=js"
export * from "./ImagesPopup.vue?vue&type=script&lang=js"

import "./ImagesPopup.vue?vue&type=style&index=0&id=1daa20b8&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1daa20b8"]])

export default __exports__